import { Icon, IconProps } from '@chakra-ui/react'

export const UpgradeIcon = ({ ...props }: IconProps) => {
  return (
    <Icon viewBox="0 0 32 32" {...props}>
      <g clipPath="url(#clip0_627_3611)">
      <path
        d="M21.3333 25.3333C21.3333 26.0666 20.7333 26.6666 20 26.6666H12C11.2667 26.6666 10.6667 26.0666 10.6667 25.3333C10.6667 24.6 11.2667 24 12 24H20C20.7333 24 21.3333 24.6 21.3333 25.3333ZM14.6667 10.6533V20C14.6667 20.7333 15.2667 21.3333 16 21.3333C16.7333 21.3333 17.3333 20.7333 17.3333 20V10.6533H19.72C20.32 10.6533 20.6133 9.93329 20.1867 9.51996L16.4667 5.81329C16.2 5.55996 15.7867 5.55996 15.52 5.81329L11.8133 9.51996C11.3867 9.93329 11.68 10.6533 12.28 10.6533H14.6667Z"
        fill="currentColor"
      />
      </g>
      <defs>
      <clipPath id="clip0_627_3611">
      <rect width="32" height="32" fill="white"/>
      </clipPath>
      </defs>
    </Icon>
  )
}
